import * as React from 'react';

function SvgAlertFilled(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <rect x={1} y={1} width={18} height={18} rx={3} fill={props.color} />
      <ellipse cx={10.035} cy={14.75} rx={0.735} ry={0.75} fill="#fff" />
      <path d="M10.05 5.75v6.75" stroke="#fff" strokeWidth={1.5} strokeLinecap="round" />
    </svg>
  );
}

export default SvgAlertFilled;
